import { create } from "zustand";
import { persist } from "zustand/middleware"; // если используем middleware для localStorage

export type TTheme = 'light' | 'dark'

type ThemeStore = {
  theme: TTheme;
  switchTheme: (theme: TTheme) => void;
};

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      // theme: "system",
      theme: "light",
      switchTheme: (newTheme) => set({ theme: newTheme }),
    }),
    {
      name: 'theme-storage',
    }
  )
);